module.exports = __webpack_public_path__ + "static/img/1-3.f6423121.png";